import { cn } from '@/lib/utils'
import { forwardRef } from 'react'

export interface HomeContentBlockProps extends React.HTMLAttributes<HTMLDivElement> {
  spacing?: 'sm' | 'base' | 'lg' | 'xl'
}

const HomeContentBlock = forwardRef<HTMLDivElement, HomeContentBlockProps>(
  ({ className, spacing = 'lg', children, ...props }, ref) => {
    const spacingClasses = {
      sm: 'space-y-4',
      base: 'space-y-6',
      lg: 'space-y-10',
      xl: 'space-y-12',
    }

    return (
      <div className={cn(spacingClasses[spacing], className)} ref={ref} {...props}>
        {children}
      </div>
    )
  },
)

HomeContentBlock.displayName = 'HomeContentBlock'

export { HomeContentBlock }
